import styled from 'styled-components'

export const Wrapper = styled.div``

export const Fieldset = styled.fieldset`
  position: relative;
  height: ${p => p.height}px;
  border: ${p => p.error ? `1px solid ${p.theme.color[p.error]}` : p.focused ? `1px solid ${p.theme.color.primary}` : '1px solid #ccc'};
  border-radius: 4px;
  background-color: ${p => p.disabled ? '#eee' : 'white'};
  transition: all 150ms ease;
  z-index:1;

  &:hover {
    border-color: ${p => !p.disabled && !p.error && p.theme.color.primary};
  }
`

export const Legend = styled.legend`
  height: 0;
  width: auto;
  padding: 0 4px;
  margin-top: 12px;
  margin-bottom: 0;
  margin-left: 12px;
  font-size: 0.8rem;
  font-weight: bold;
  // transform: scale(0.75);
  color: transparent;
`

export const InputField = styled.input`
  width: 100%;
  height: 100%;
  padding: 0 15px;
  background-color: transparent;
  border: none;
  font-size: 16px;
  color: #444;

  &:focus {
    outline: none;
  }
`

export const Textarea = styled.textarea`
  width: 100%;
  padding: 18px 15px;
  background-color: transparent;
  border: none;
  font-size: 16px;
  color: #444;
  resize: none;

  padding-top: 0px;
  margin-top: 15px;

  &:focus {
    outline: none;
  }
`

export const Label = styled.label`
  position: absolute;
  top: ${p => (p.focused || p.inputLength || p.fixed) ? '-1' : p.height / 2 - 1}px;
  left: ${p => (p.focused || p.inputLength || p.fixed) ? '16px' : '15px'};
  display: block;
  align-items: center;
  margin-bottom: 0;
  line-height: 0;
  font-weight: ${p => (p.focused || p.inputLength || p.fixed) ? 'bold' : 'normal'};
  color: ${p => p.error ? p.theme.colors[p.error] : p.focused ? p.theme.colors.primary : 'rgba(0, 0, 0, 0.5)'};
  font-size: ${p => (p.focused || p.inputLength || p.fixed) ? '0.8rem' : '1rem'};
  // transform: ${p => (p.focused || p.inputLength) ? 'scale(0.75)' : 'scale(1)'};
  z-index: ${p => p.disabled ? '0' : '-1'};
  transition: all 150ms ease;
`